import React from "react";
import AlertIcon from "../../resources/icons/alert-circle.svg";

function ConfirmationModal({ isOpen, onConfirm, onCancel }) {
  if (!isOpen) return null;

  return (
    <div id="confirmation-modal-overlay" className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-20 ">
      <div id="confirmation-modal" className="bg-white p-6 rounded-2xl shadow-lg w-fit flex flex-col items-center">
        <img src={AlertIcon} alt="" className="w-14" />
        <h2 className="text-xl font-semibold mb-4 text-black">Unsaved Changes</h2>
        <p className="mb-14 text-[#667085]">
        Do you want to save without verification comments?
        </p>
        <div className="flex justify-end gap-4 w-full mb-3">
          <button
            id="confirmation-modal-no-button"
            onClick={onCancel}
            className="px-4 py-2 rounded-lg hover:bg-[#f7f7f7] w-1/2 border-[1.5px] border-[#D0D5DD]"
          >
            No
          </button>
          <button
            id="confirmation-modal-yes-button"
            onClick={onConfirm}
            className="px-4 py-2 bg-[#D92D20] text-white rounded-lg hover:bg-red-700 w-1/2"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
